import React, { useRef, useState } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

export default function VideoPlayer({ src, poster, className = '' }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
      setShowControls(true);
    }
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  return (
    <div className="relative">
      <video
        ref={videoRef}
        src={src}
        poster={poster || undefined}
        className={`cursor-pointer rounded-xl ${className} border border-gray-100`}
        controls={showControls}
        onPause={handlePause}
        onPlay={() => setIsPlaying(true)}   
      />
      {!isPlaying && (
        <div className="absolute inset-0 bg-black/10 flex items-center justify-center">
          <span
            className="p-2 rounded-full bg-white/50 cursor-pointer"
            onClick={handlePlay}
          >
            <PlayArrowIcon className="text-[#008080] size-6" />
          </span>
        </div>
      )}
    </div>
  );
}
